import { useMutation } from "@apollo/client/react";
import LoadingButton from "@repo/components/src/shared/loadingButton";
import { Button, ButtonText } from "@repo/components/src/ui/button";
import { Icon } from "@repo/components/src/ui/icon";
import {
  Popover,
  PopoverBackdrop,
  PopoverContent,
} from "@repo/components/src/ui/popover";
import { Pressable } from "@repo/components/src/ui/pressable";
import { PinBrandChatDocument } from "@repo/graphql/documents/chat/mutation.generated";
import { Ellipsis } from "lucide-react-native";
import React, { useState } from "react";
type Props = {
  hovered: boolean;
  chatId: string;
  isPinned: boolean;
};

const ChatSelectorButtonActions = React.memo((props: Props) => {
  const { hovered, isPinned, chatId } = props;
  const [open, setOpen] = useState(false);
  const [pinBrandChat, { loading }] = useMutation(PinBrandChatDocument, {
    onCompleted: () => setOpen(false),
  });
  return (
    <Popover
      placement="bottom right"
      offset={5}
      isOpen={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      className={"rounded-lg"}
      trigger={({ ...triggerProps }) => {
        return (
          <Pressable {...triggerProps}>
            {(pressableProps) => {
              return (
                <Icon
                  as={Ellipsis}
                  size="md"
                  className={`bg-background-400 rounded-md p-[2px] text-typography-0 ${pressableProps.hovered ? "bg-background-800" : ""}`}
                  hidden={!hovered}
                />
              );
            }}
          </Pressable>
        );
      }}
    >
      <PopoverBackdrop />
      <PopoverContent size="xs" className="p-2">
        <LoadingButton
          action="elevated"
          className="justify-start w-full"
          onPress={() => pinBrandChat({ variables: { chatId } })}
          loading={loading}
        >
          {isPinned ? "Despinar" : "Pinar"}
        </LoadingButton>
        <Button action="elevated" className="justify-start w-full">
          <ButtonText>Marcar como no leído</ButtonText>
        </Button>
        <Button action="elevated" className="justify-start w-full">
          <ButtonText>Eliminar chat</ButtonText>
        </Button>
      </PopoverContent>
    </Popover>
  );
});

ChatSelectorButtonActions.displayName = "ChatSelectorButtonActions";

export default ChatSelectorButtonActions;
